import { logger } from '../logging'

export function getDisplayCountry(country: string, locale = 'en') {
  try {
    if (typeof Intl !== 'undefined' && Intl.DisplayNames) {
      const englishRegions = new Intl.DisplayNames([locale], { type: 'region' })
      return englishRegions.of(country)
    }
  } catch (e) {
    if (e instanceof Error) {
      logger().warn(`Error getting display country for ${country} and locale: ${locale}`, { country, locale }, e)
    }
  }
  // Fallback to country code if Intl.DisplayNames is not available
  return country
}
